import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2846b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "code-1" }
const _hoisted_3 = {
  key: 0,
  class: "code-season"
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "bottom-line" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "spacer"
}
const _hoisted_10 = {
  key: 1,
  class: "special-code"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "spacer"
}
const _hoisted_17 = {
  key: 1,
  class: "special-code"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "code-season"
}
const _hoisted_21 = ["textContent"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_23 = ["textContent"]

import { PropType } from 'vue';
import { ISearchResult, EPlateType, MonthShortMap, ECarType } from '@/classes/interfaces/data';


export default /*#__PURE__*/_defineComponent({
  props: {
  License: { type: Object as PropType<ISearchResult>, required: true },
  Small: { type: Boolean, required: false, default: false },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["license", `cartype-${__props.License.CarType} ${__props.Small ? 'small' : ''}`])
  }, [
    (__props.License.CarType == _unref(ECarType).MotorCycle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(__props.License.Code1), 1),
          (__props.License.IsSeason)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (__props.License.SeasonStart != null)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      textContent: _toDisplayString(_unref(MonthShortMap)[__props.License.SeasonStart])
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                _hoisted_5,
                (__props.License.SeasonEnd != null)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      textContent: _toDisplayString(_unref(MonthShortMap)[__props.License.SeasonEnd])
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(__props.License.Code2), 1),
            _hoisted_8,
            _createElementVNode("div", null, _toDisplayString(__props.License.Code3), 1),
            (__props.License.PlateType != _unref(EPlateType).Default)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : _createCommentVNode("", true),
            (__props.License.PlateType != _unref(EPlateType).Default)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (__props.License.PlateType == _unref(EPlateType).Electric)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "E"))
                    : _createCommentVNode("", true),
                  (__props.License.PlateType == _unref(EPlateType).OldTimer)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "H"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", null, _toDisplayString(__props.License.Code1), 1),
          _hoisted_14,
          _createElementVNode("div", null, _toDisplayString(__props.License.Code2), 1),
          _hoisted_15,
          _createElementVNode("div", null, _toDisplayString(__props.License.Code3), 1),
          (__props.License.PlateType != _unref(EPlateType).Default || __props.License.IsSeason)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16))
            : _createCommentVNode("", true),
          (__props.License.PlateType != _unref(EPlateType).Default)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (__props.License.PlateType == _unref(EPlateType).Electric)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "E"))
                  : _createCommentVNode("", true),
                (__props.License.PlateType == _unref(EPlateType).OldTimer)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "H"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (__props.License.IsSeason)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (__props.License.SeasonStart != null)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      textContent: _toDisplayString(_unref(MonthShortMap)[__props.License.SeasonStart])
                    }, null, 8, _hoisted_21))
                  : _createCommentVNode("", true),
                _hoisted_22,
                (__props.License.SeasonEnd != null)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      textContent: _toDisplayString(_unref(MonthShortMap)[__props.License.SeasonEnd])
                    }, null, 8, _hoisted_23))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 2))
}
}

})